<template>
  <div class="chart-metric">
    <div class="header">
      {{ item && item.title }}
    </div>
    <div class="value">
      {{ data[0] && data[0].avgNum }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },
    item: {
      type: Object,
      default: () => {}
    }
  }
};
</script>

<style lang="scss" scoped>
.chart-metric {
  height: 100%;
  @include dropshadow-effect;
  border-radius: 1.0625em;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}
.header {
  font-size: 1.25rem;
  color: $font-primary;
  line-height: 1.563rem;
  font-family: $semi-bold;
  text-align: center;
}
.value {
  font-size: 1.625rem;
  color: $color-brand-accent;
  line-height: 2.063rem;
  font-family: $semi-bold;
  text-align: center;
}
</style>
